import React from "react";
import "../../App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { AppBar, Toolbar } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import logo from "../../assets/img/cw_logo.png";

const styles = {
  menu_button: {
    marginRight: -16,
  },
  title: {
    flexGrow: 1,
    color: "black",
    marginTop: 10,
    fontWeight: "bold",
    fontFamily: "Open Sans",
  },
  list: {
    width: "80%",
    height: "100%",
    marginLeft: "10%",
  },
  drawerPaper: {
    backgroundColor: "rgba(52, 52, 52, 0.9)",
    width: "45%",
    background: "inherit",
    borderRadius: "2px",
    overflow: "hidden",
    content: "",
  },
  list_title: {
    color: "white",
    "&:hover": {
      color: "#F6277F",
    },
    fontSize: "3rem",
    "@media (min-width:200px)": {
      fontSize: "1rem",
    },
    "@media (min-width:600px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:960px)": {
      fontSize: "2rem",
    },
    fontWeight: "bold",
    fontFamily: "Open Sans",
  },
  bottom_bar: {
    marginTop: 24,
    backgroundColor: "#FAFAFA",
    borderWidth: 1,
    borderColor: "#EAEAEA",
    borderStyle: "solid",
  },
  parent: {
    "&:hover": {
      backgroundColor: "#FFF",
    },
    paddingLeft: "10%",
  },
};

class TopAppBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      selectedIndex: 0,
      right: false,
    };
  }

  handleClick = () => {
    this.setState((state) => ({ open: !state.open }));
  };

  handleListItemClick = (index) => {
    this.setState({ selectedIndex: index });
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid container style={{ marginBottom: 70 }}>
        <AppBar position="fixed" style={{ backgroundColor: "#FAFAFA" }}>
          <Toolbar>
            <Grid justify="space-between" container>
              <Grid item>
                <img
                  alt=""
                  style={{ padding: 5, height: 40, boxSizing: "unset" }}
                  src={logo}
                />
              </Grid>
              <Grid item>
                <Typography
                  variant="h5"
                  style={{
                    flexGrow: 1,
                    color: "black",
                    marginTop: 10,
                    fontWeight: "bold",
                    fontFamily: "Open Sans",
                  }}
                >
                  <Link
                    to="/"
                    style={{
                      color: "black",
                      fontFamily: "Open Sans",
                      textDecoration: "none",
                    }}
                  >
                    <u>ADMIN PAGE</u>
                  </Link>
                </Typography>
              </Grid>
              <Grid item />
            </Grid>
          </Toolbar>
        </AppBar>
      </Grid>
    );
  }
}

TopAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TopAppBar);
